// extracted by mini-css-extract-plugin
export default {"mainLabel":"Circle_mainLabel__End45","total":"Circle_total__keV6T","label":"Circle_label__InLhq","circle":"Circle_circle__egOIP"};